import { useApiMutation, useLocalizedApiQuery } from "../services/react-query";

export const useGetSurveys = (eventId, page, limit) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["surveys", { eventId, page, limit }],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: `/surveys?eventId=${eventId}`,
      method: "GET",
      params: { page, limit },
    },
  });

export const useGetSurveyById = (id) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["survey", { id }], enabled: !!id },
    fetchOptions: { url: `/surveys/${id}`, method: "GET" },
  });

export const usePatchSurvey = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchSurvey" },
    fetchOptions: { url: `/surveys/${id}`, method: "PATCH" },
    invalidateQueryKeys: [["surveys"], ["survey", { id }]],
    successMessage: { title: "Survey has been updated", color: "green" },
  });

export const useCreateSurvey = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateSurvey" },
    fetchOptions: { url: "/surveys", method: "POST" },
    invalidateQueryKeys: [["surveys"]],
    successMessage: { title: "Survey has been created", color: "green" },
  });

export const useDeleteSurvey = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteSurvey" },
    fetchOptions: { url: `/surveys/${id}`, method: "DELETE" },
    invalidateQueryKeys: [["surveys"]],
    successMessage: { title: "Survey has been deleted", color: "green" },
  });

export const useCreateSurveyQuestion = (surveyId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateSurveyQuestion" },
    fetchOptions: { url: `/surveys/${surveyId}/questions`, method: "POST" },
    invalidateQueryKeys: [["survey"], ["surveyQuestions"]],
    successMessage: {
      title: "Survey question has been created",
      color: "green",
    },
  });

export const useUpdateSurveyQuestion = ({ surveyId, questionId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useUpdateSurveyQuestion" },
    fetchOptions: {
      url: `/surveys/${surveyId}/questions/${questionId}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["survey"], ["surveyQuestions"], ["surveyQuestion"]],
    successMessage: {
      title: "Survey question has been updated",
      color: "green",
    },
  });

export const usePatchSurveyQuestionOrder = (surveyId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchSurveyQuestionOrder" },
    fetchOptions: {
      url: `/surveys/${surveyId}/questions/order`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["survey"], ["surveyQuestions"]],
    successMessage: {
      title: "Survey question order has been updated",
      color: "green",
    },
  });

export const useDeleteSurveyQuestion = ({ surveyId, questionId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: ["useDeleteSurveyQuestion", surveyId] },
    fetchOptions: {
      url: `/surveys/${surveyId}/questions/${questionId}`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["survey"], ["surveyQuestions"], ["surveyQuestion"]],
    successMessage: {
      title: "Survey question has been deleted",
      color: "green",
    },
  });

export const useGetAllQuestionsForSurvey = (surveyId) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["surveyQuestions", { surveyId }],
      enabled: !!surveyId,
    },
    fetchOptions: { url: `/surveys/${surveyId}/questions`, method: "GET" },
  });

export const useGetSurveyQuestionById = (surveyId, questionId) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["surveyQuestion", { surveyId, questionId }],
      enabled: !!surveyId && !!questionId,
    },
    fetchOptions: {
      url: `/surveys/${surveyId}/questions/${questionId}`,
      method: "GET",
    },
  });

export const useGetResponsesForSurvey = (surveyId) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["surveyResponses", { surveyId }],
      enabled: !!surveyId,
    },
    fetchOptions: { url: `/surveys/${surveyId}/responses`, method: "GET" },
  });
